<nz-modal [(nzVisible)]="modalVisible.email" nzTitle="Send Email" [nzWidth]="'70vw'"
  [nzWrapClassName]="showPreview? 'email-transaction-modal': 'report-transaction-modal'" [nzMaskClosable]="false"
  [nzFooter]="footer" (nzOnCancel)="closeModal('email')" (nzAfterOpen)="onEmailModalAfterOpen()">
  <ng-container *nzModalContent>
    <div nz-row>
      <div nz-col [nzMd]="showPreview? 10: 24" [nzSm]="24">
        <form #emailFormElement class="sender-form" nz-form novalidate [formGroup]="emailFormGroup"
          (ngSubmit)="onEmailFormSubmit($event)">
          <div aria-hidden="true" style="position: absolute; left: -9999px; top: -9999px; height: 0; width: 0; overflow: hidden;">
            <label for="txCompanyWebsite">Website</label>
            <input type="text" id="txCompanyWebsite" name="companyWebsite" [(ngModel)]="data.companyWebsite"
              [ngModelOptions]="{standalone: true}" tabindex="-1" autocomplete="off" />
          </div>
          <div class="sender-info">
            <div class="info-block">
              <div class="block">
                <div class="title">Name:</div>
                <input nz-input type="text" formControlName="receipientName" />
              </div>
              <div class="block">
                <div class="title">Send To:</div>
                <div class="input-container">
                  <input class="email-template-required-field" nz-input type="email" formControlName="receipientEmail"
                    [nzAutocomplete]="recipientEmailAuto" placeholder="Enter email or select from suggestions"
                    [nzStatus]="hasInvalidEmails('receipientEmail') ? 'error' : ''" />
                  <nz-autocomplete nzBackfill #recipientEmailAuto>
                    <nz-auto-optgroup *ngIf="data.primaryEmail && shouldShowPrimaryEmail()" nzLabel="Primary Email">
                      <nz-auto-option [nzValue]="data.primaryEmail"
                        [nzDisabled]="isEmailDisabled(data.primaryEmail, 'receipientEmail')">
                        {{ data.primaryEmail }}
                      </nz-auto-option>
                    </nz-auto-optgroup>
                    <nz-auto-optgroup *ngIf="filteredEmailSuggestions && filteredEmailSuggestions.length > 0"
                      nzLabel="Secondary Email">
                      <nz-auto-option *ngFor="let email of filteredEmailSuggestions" [nzValue]="email"
                        [nzDisabled]="isEmailDisabled(email, 'receipientEmail')">
                        {{ email }}
                      </nz-auto-option>
                    </nz-auto-optgroup>
                  </nz-autocomplete>
                  <button type="button" nz-button nzType="primary" (click)="toggleBccField()"
                    class="toggle-bcc-button custom-blue-button">
                    {{ isBccVisible ? 'BCC' : 'BCC' }}
                  </button>
                </div>
                <small class="text-red" *ngIf="emailFieldShowsError('receipientEmail', 'required')">Recipient Email is
                  required</small>
                <small class="text-red" *ngIf="hasInvalidEmails('receipientEmail')">Invalid Email Format</small>
              </div>

              <!-- CC Field -->
              <div class="block">
                <div class="title ccList">CC:</div>
                <nz-select nzMode="tags" nzPlaceHolder="Select CC emails or add new ones..." formControlName="ccList"
                  style="width: 100%">
                  <nz-option-group nzLabel="Primary Email">
                    <nz-option *ngIf="data.primaryEmail" [nzValue]="data.primaryEmail" [nzLabel]="data.primaryEmail"
                      [nzDisabled]="isEmailDisabled(data.primaryEmail, 'ccList')">
                    </nz-option>
                  </nz-option-group>
                  <nz-option-group nzLabel="Secondary Email">
                    <nz-option *ngFor="let email of data.ccOptions" [nzLabel]="email" [nzValue]="email"
                      [nzDisabled]="isEmailDisabled(email, 'ccList')">
                    </nz-option>
                  </nz-option-group>
                </nz-select>
              </div>

              <!-- BCC Field -->
              <div class="block" *ngIf="isBccVisible">
                <div class="title">BCC:</div>
                <nz-select nzMode="tags" nzPlaceHolder="Select BCC emails or add new ones..." formControlName="bccList"
                  style="width: 100%">
                  <nz-option-group nzLabel="Primary Email">
                    <nz-option *ngIf="data.primaryEmail" [nzValue]="data.primaryEmail" [nzLabel]="data.primaryEmail"
                      [nzDisabled]="isEmailDisabled(data.primaryEmail, 'bccList')">
                    </nz-option>
                  </nz-option-group>
                  <nz-option-group nzLabel="Secondary Email">
                    <nz-option *ngFor="let email of data.ccOptions" [nzLabel]="email" [nzValue]="email"
                      [nzDisabled]="isEmailDisabled(email, 'bccList')">
                    </nz-option>
                  </nz-option-group>
                </nz-select>
                <small class="text-red" *ngIf="hasInvalidEmails('bccList')">Invalid Email Format</small>
              </div>
              <div class="block">
                <div class="title">Subject:</div>
                <input class="email-template-required-field" nz-input type="text" formControlName="subject"
                  [nzStatus]="emailFieldShowsError('subject', 'required') ? 'error' : ''" />
                <small class="text-red" *ngIf="emailFieldShowsError('subject', 'required')">Email Subject is
                  required</small>
              </div>

              <div class="block">
                <div class="title">Message:</div>
                <textarea nz-input rows="8" style="resize: none;" formControlName="message">
                </textarea>
                <div [class.text-red]="errors.message" class="small-remark">Attachment Link will be generated upon
                  submission. Please ensure that the [link] tag stays in the content of the message.</div>
              </div>
            </div>
            <div class="button-block">
              <div class="custom-button-container">
                <button type="button" nz-button nzType="default" (click)="closeModal('email')">Cancel</button>
                <button type="submit" nz-button nzType="primary">Send</button>
              </div>
            </div>
          </div>
        </form>
      </div>

      @if (showPreview) {

      <div nz-col [nzMd]="14" [nzSm]="24">
        <!-- Please dont modify this part to class, all css should be inline style -->
        <!-- Will be used for email rendering in later stage-->
        <div class="email-preview" id="email-preview">
          <div [innerHTML]="emailPreview" style="margin-bottom: 20px;" class="hidden"></div>
          <!--Header-->
          <div style="display: flex; width: 100%; padding-top: 25px; padding-bottom: 10px;">
            <div style="display: flex; margin: 0 auto;">
              <!-- Company Image -->
              <div style="margin-right: 10px;">
                <img [src]="companyLogo" style="width: auto;height: 40px;">
              </div>

              <div style="line-height: 16px; margin-top: 3px;">
                <div>
                  <span style="font-weight: bold; color: #08306B; font-size: 19px;">{{data.companyName}}</span>
                  <span style="font-size: 12px; margin-left: 5px;"><i>({{data.regNo}})</i></span>
                </div>
                <div>
                  <span style="font-size: 12px;">{{data.phoneNo}}</span>
                  <span style="font-size: 12px; margin-left: 10px;">{{data.email}}</span>
                </div>
              </div>
            </div>
          </div>
          <hr>

          <div class="preview-detail-container" style="padding-left: 20px; padding-right: 40px;">
            <!-- Item Header-->
            <table style="width: 100%;">
              <tr>
                <td style="vertical-align: top;">
                  <div>
                    <div style="line-height: 18px; margin-bottom: 10px;">
                      <div style="font-weight: 500; font-size: 15px;">{{data.recipientBillTargetLabel}}</div>
                      <div>{{data.receipientName}}</div>
                    </div>
                    <div style="line-height: 18px; margin-bottom: 10px;">
                      <div style="font-weight: 500; font-size: 15px;">Date</div>
                      <div>{{data.docDate}}</div>
                    </div>
                  </div>
                </td>
                <td align="right">
                  <div>
                    <div style="line-height: 18px; margin-bottom: 10px;">
                      <div style="font-weight: 500; font-size: 15px;">{{data.transactionType}}</div>
                      <div>{{data.docCode}}</div>
                    </div>
                    @if (data.dueDate) {
                    <div style="line-height: 18px; margin-bottom: 10px;">
                      <div style="font-weight: 500; font-size: 15px;">Due Date</div>
                      <div>{{data.dueDate}}</div>
                    </div>
                    }
                    @if (data.term) {
                    <div style="line-height: 18px; margin-bottom: 10px;">
                      <div style="font-weight: 500; font-size: 15px;">Term</div>
                      <div>{{data.term}}</div>
                    </div>
                    }
                  </div>
                </td>
              </tr>
            </table>
            <!-- END:Item Header -->

            <!-- Item Details -->
            <div style="padding: 0 30px; margin: 25px 0;">
              <ng-container [ngSwitch]="previewTemplateKey">
                <app-transaction-preview-receive-payment *ngSwitchCase="templateKeys.receivePayment"
                  [currencyCode]="data.currencyCode" [items]="data.knockoffItems" [totalAmount]="data.knockoffTotal"
                  [totalPayment]="data.paymentTotal" [unmatchedAmount]="data.unmatchedAmount">
                </app-transaction-preview-receive-payment>
                <app-transaction-preview-pay-bill *ngSwitchCase="templateKeys.apPayBills"
                  [currencyCode]="data.currencyCode" [knockoffItems]="data.knockoffItems" [unmatchedAmount]="data.unmatchedAmount"
                  [accountItems]="data.accountItems" [accountTotal]="data.accountTotal" [taxableAmount]="data.taxableAmount"
                  [taxAmount]="data.taxAmount" [netTotal]="data.netTotal">
                </app-transaction-preview-pay-bill>
                <app-transaction-preview-customer-refund *ngSwitchCase="templateKeys.customerRefund"
                  [currencyCode]="data.currencyCode" [knockoffItems]="data.knockoffItems" [unmatchedAmount]="data.unmatchedAmount"
                  [accountItems]="data.accountItems" [accountTotal]="data.accountTotal" [taxableAmount]="data.taxableAmount"
                  [taxAmount]="data.taxAmount" [netTotal]="data.netTotal">
                </app-transaction-preview-customer-refund>
                <app-transaction-preview-credit-note *ngSwitchCase="templateKeys.creditNote"
                  [currencyCode]="data.currencyCode" [items]="data.accountItems" [totalAmount]="data.accountTotal"
                  [taxableAmount]="data.taxableAmount" [taxAmount]="data.taxAmount" [netTotal]="data.netTotal">
                </app-transaction-preview-credit-note>
                <app-transaction-preview-bill *ngSwitchCase="templateKeys.bill"
                  [currencyCode]="data.currencyCode" [items]="data.accountItems" [totalAmount]="data.accountTotal"
                  [taxableAmount]="data.taxableAmount" [taxAmount]="data.taxAmount" [netTotal]="data.netTotal">
                </app-transaction-preview-bill>
                <app-transaction-preview-debit-note *ngSwitchCase="templateKeys.debitNote"
                  [currencyCode]="data.currencyCode" [items]="data.accountItems" [totalAmount]="data.accountTotal"
                  [taxableAmount]="data.taxableAmount" [taxAmount]="data.taxAmount" [netTotal]="data.netTotal">
                </app-transaction-preview-debit-note>

                <ng-container *ngSwitchDefault>
                  <ng-container *ngTemplateOutlet="defaultItemsTemplate"></ng-container>
                </ng-container>
              </ng-container>

              <div *ngIf="previewTemplateKey == templateKeys.defaultInvoice"
                style="display: flex; margin-bottom: 10px; padding-left: 20px; padding-right: 35px; line-height: 24px;">
                <div style="margin: 0 0 0 auto;">
                  <table cellpadding="0">
                    <tr>
                      <td style="text-align: right;"><b>TAXABLE AMOUNT</b></td>
                      <td style="text-align: right; font-weight: 500; padding-left: 20px;">{{data.currencyCode}}
                        {{data.taxableAmount | number: '1.2-2'}}</td>
                    </tr>
                    <tr>
                      <td style="text-align: right;"><b>TAX</b></td>
                      <td style="text-align: right; font-weight: 500; padding-left: 20px;">{{data.currencyCode}}
                        {{data.taxAmount | number: '1.2-2'}}</td>
                    </tr>
                    <tr>
                      <td style="text-align: right;"><b>NET TOTAL</b></td>
                      <td style="text-align: right; font-weight: 500; padding-left: 20px;">{{data.currencyCode}}
                        {{data.netTotal | number: '1.2-2'}}</td>
                    </tr>
                  </table>
                </div>
              </div>

              <!-- <div *ngIf="previewTemplateKey === templateKeys.receivePayment"
                style="display: flex; margin-bottom: 10px; padding-left: 20px; padding-right: 35px; line-height: 24px;">
                <div style="margin-left: auto; font-weight: 600; font-size: 14px;">
                  <table cellpadding="0">
                    <tr>
                      <td style="text-align: right;"><b>UNMATCHED AMOUNT</b></td>
                      <td style="text-align: right; font-weight: 500; padding-left: 20px;">{{data.currencyCode}}
                        {{data.unmatchedAmount | number: '1.2-2'}}</td>
                    </tr>
                  </table>
                </div>
              </div> -->
              <!-- END:Item Details -->

              <div style="background-color: #08306B; margin-bottom: 15px; height: 80px; width: 100%; display: flex;">
                <div style="color: white; font-weight: 600; font-size: 17px; display: flex; margin: auto auto;">
                  <div>TOTAL AMOUNT</div>
                  <div style="margin-left: 15px;">{{ data.currencyCode }} {{ data.totalAmount | number: '1.2-2' }}</div>
                </div>
              </div>
              <div style="font-size: 12px; line-height: 12px;">Please note: If you suspect this document is fraudulent
                or
                not intended for you, kindly disregard it or consult the business owner before taking any action.</div>

              <div style="margin-top: 20px; display: flex; width: 100%;">
                <div style="text-align: center; margin: 0 auto;">
                  <img
                    src="https://qnestorage.blob.core.windows.net/cloud-accounting/Email%20Resouces/official-logo-new-colored.png"
                    style="width: auto; height: 25px; margin-bottom: 10px;" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      }
    </div>
  </ng-container>

  <ng-template #defaultItemsTemplate>
    <table border="1" cellpadding="8" style="width: 100%; border-collapse: collapse;">
      <tr style="text-align: center;">
        <th style="padding: 5px; border: 1px solid #000000;">#</th>
        <th style="padding: 5px; border: 1px solid #000000;">Product/Description</th>
        <th style="padding: 5px; border: 1px solid #000000;">Amount</th>
        <th style="padding: 5px; border: 1px solid #000000;">Qty</th>
        <th style="padding: 5px; border: 1px solid #000000;">Total</th>
      </tr>
      @for (
      item of data.items || [];
      track item;
      let index = $index;
      ) {
      <tr style="border: 1px solid #000000">
        <td style="text-align: center; border: 1px solid #000000;">{{ index + 1 }}</td>
        <td style="line-height: 16px; border: 1px solid #000000;">
          <div style="font-weight: bold; font-size: 14px; color: #08306B;">{{ item.code }}</div>
          <div style="font-size: 12px;">{{ item.description }}</div>
        </td>
        <td style="font-size: 13px; text-align: end; border: 1px solid #000000;">{{ item.unitPrice | number: '1.2-2' }}
        </td>
        <td style="text-align: center; border: 1px solid #000000;">{{ item.quantity | number: '1.0-3' }}</td>
        <td style="font-weight: 500; font-size: 13px; text-align: end; border: 1px solid #000000;">{{ item.total |
          number: '1.2-2' }}</td>
      </tr>
      }
      @if (!(data.items?.length)) {
      <tr>
        <td colspan="5" style="text-align: center; padding: 12px; border: 1px solid #000000;">No items available.</td>
      </tr>
      }
    </table>
  </ng-template>

  <ng-template #footer>
    <div nz-row>
      <div nz-col nzSpan="10">
        <div class="hide-in-full">
          <button type="button" nz-button nzType="default" (click)="closeModal('email')">Cancel</button>
          <button type="button" nz-button nzType="primary" (click)="submitEmailFormFromFooter()">Send</button>
        </div>
      </div>
      <div nz-col nzSpan="14"></div>
    </div>
  </ng-template>
</nz-modal>

<nz-modal [(nzVisible)]="modalVisible.whatsapp" nzTitle="Send Via WhatsApp" nzWrapClassName="whatsapp-transaction-modal"
  (nzOnOk)="generateLink()" (nzOnCancel)="closeModal('whatsapp')">
  <ng-container *nzModalContent>
    <form nz-form #whatsappForm="ngForm" labelWidth="0">
      <div class="sender-info">
        <div class="block">
          <div class="title">Recipient:</div>
          <app-text-input name="receipientPhone" required [(ngModel)]="data.receipientPhone" maxlength="100"
            app-mobile-input [allowDialCode]="false" [autoCompleteData]="data.phoneSuggestions??data.receipientPhones"
            (ngModelChange)="textChanged('receipientPhone')"></app-text-input>
          <small class="text-red" *ngIf="errors.receipientPhone">Receipient Phone Number is required</small>
          <div class="small-remark">e.g. 60122003080</div>
        </div>

        <div class="block">
          <div class="title">Message:</div>
          <textarea nz-input rows="8" style="resize: none;" name="message" [(ngModel)]="data.message"
            (ngModelChange)="textChanged('message')"></textarea>
          <div [class.text-red]="errors.message" class="small-remark">Attachment Link will be generated upon submission.
            Please ensure that the [link] tag stays in the content of the message.</div>
        </div>
      </div>
    </form>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="modalVisible.telegram" nzTitle="Send Via Telegram" nzWrapClassName="telegram-transaction-modal"
  (nzOnOk)="generateLink()" (nzOnCancel)="closeModal('telegram')">
  <ng-container *nzModalContent>
    <form nz-form #telegramForm="ngForm" labelWidth="0">
      <div class="sender-info">
        <div class="block">
          <div class="title">Message:</div>
          <textarea nz-input rows="8" style="resize: none;" name="message" [(ngModel)]="data.message"
            (ngModelChange)="textChanged('message')"></textarea>
          <div [class.text-red]="errors.message" class="small-remark">Attachment Link will be generated upon submission.
            Please ensure that the [link] tag stays in the content of the message.</div>
        </div>
      </div>
    </form>
  </ng-container>
</nz-modal>

<ng-template #retryLink>
  <a (click)="copyLink()">Click here</a> to copy to your clipboard.
</ng-template>



